export const uploadPresignedFile = async (file: File, url: string) => {
    const formData = new FormData()
    formData.append('file', file)

    const response = await fetch(url, {
        method: 'PUT',
        body: formData,
        headers: {
            'Content-Type': file.type,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to upload file')
    }

    return true
}

export const putPresignedFile = async (
    file: Blob,
    preSignedUrl: string,
    contentType: string,
) => {
    const response = await fetch(preSignedUrl, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': contentType,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to upload file')
    }

    return true
}